import {
  DeleteAccountErrorCode,
  DeleteAccountResult,
  DeleteAccountRepository,
} from '@domain/model/Account/DeleteAccount/DeleteAccountRepository';
import {request} from '@infra/api/fetch/request';

const KNOWN_CODES: ReadonlyArray<DeleteAccountErrorCode> = [
  'ERR_BOX_PENDING',
  'ERR_PAY_PENDING',
  'ERR_RETURN_PENDING',
  'ERR_CURRENT_BOX_ACTIVE',
  'ERR_UNSUBSCRIBE_FREQUENCY',
  'ERR_FRAUD',
];

type UnsubscribeError = {code?: string};
type UnsubscribeBody = {
  status?: 'ok' | 'fail';
  data?: {errors?: UnsubscribeError[]; code?: string; msg?: string};
};

const toPendingCodes = (errors: UnsubscribeError[]): DeleteAccountErrorCode[] =>
  Array.from(new Set(errors.map(({code}) => code))).filter((code): code is DeleteAccountErrorCode =>
    KNOWN_CODES.includes(code as DeleteAccountErrorCode),
  );

export const ApiDeleteAccountRepository: DeleteAccountRepository = {
  deleteAccount: async (): Promise<DeleteAccountResult> => {
    try {
      const body = await request<UnsubscribeBody>({url: '/web/api/users/me/unsubscribe', method: 'POST'});

      if (body?.status === 'ok') {
        return {outcome: 'success'};
      }

      if (body?.status === 'fail') {
        const {data} = body;

        if (data && Array.isArray(data.errors)) {
          return {outcome: 'pendingActions', codes: toPendingCodes(data.errors)};
        }

        if (data?.code === 'ERR_USER_ALREADY_DELETED') {
          return {outcome: 'success'};
        }
      }

      return {outcome: 'genericError'};
    } catch {
      return {outcome: 'genericError'};
    }
  },
};
